import AWS from 'aws-sdk/global'
import defaultValues from '../lib/defaultValues.js'
import S3 from 'aws-sdk/clients/s3'

const state = {
  uniqueId: defaultValues.uniqueId,

  // Functionality implications
  estimatesAllowed: defaultValues.propertyEstimatesAllowed,
  commentsAllowed: defaultValues.propertyCommentsAllowed,

  // Administrative information
  listType: defaultValues.propertyListType,
  specialCircumstances: defaultValues.propertySpecialCircumstances,
  brokerage: defaultValues.propertyBrokerage,
  mlsId: defaultValues.propertyMlsId,
  parcelId: JSON.parse(JSON.stringify(defaultValues.propertyParcelId)),
  latitude: defaultValues.propertyLatitude,
  longitude: defaultValues.propertyLongitude,
  geoPoint: defaultValues.propertyGeoPoint,
  expectedMarketDate: defaultValues.propertyExpectedMarketDate,
  downloadTime: defaultValues.propertyDownloadTime,

  // Overview information
  status: defaultValues.propertyStatus,
  contingency: defaultValues.propertyContingency,
  price: defaultValues.propertyPrice,
  bedroomCount: defaultValues.propertyBedroomCount,
  bathroomCount: defaultValues.propertyBathroomCount,
  lotAcres: defaultValues.propertyLotAcres,
  lotSqft: defaultValues.propertyLotSqft,
  houseSqft: defaultValues.propertyHouseSqft,
  yearBuilt: defaultValues.propertyYearBuilt,
  foundationSize: defaultValues.propertyFoundationSize,
  stories: defaultValues.propertyStories,
  style: defaultValues.propertyStyle,
  manufacturedHome: defaultValues.propertyManufacturedHome,
  availableStarting: defaultValues.propertyAvailableStarting,

  // Rental info
  applicationFee: defaultValues.propertyApplicationFee,
  requiredBackgroundCheck: defaultValues.propertyRequiredBackgroundCheck,
  minLeaseMonths: defaultValues.propertyMinLeaseMonths,
  smokingPermitted: defaultValues.propertySmokingPermitted,
  laundryAvailability: defaultValues.propertyLaundryAvailability,
  ownerPays: JSON.parse(JSON.stringify(defaultValues.propertyOwnerPays)),
  tenantPays: JSON.parse(JSON.stringify(defaultValues.propertyTenantPays)),
  securityDeposit: defaultValues.propertySecurityDeposit,
  fees: JSON.parse(JSON.stringify(defaultValues.propertyFees)),
  prepaidRent: defaultValues.propertyPrepaidRent,

  // Construction info
  newConstruction: defaultValues.propertyNewConstruction,
  builderName: defaultValues.propertyBuilderName,
  projectedCompletionDate: defaultValues.propertyProjectedCompletionDate,
  modelLocation: defaultValues.propertyModelLocation,
  modelHours: defaultValues.propertyModelHours,
  lowPriceRange: defaultValues.propertyLowPriceRange,
  highPriceRange: defaultValues.propertyHighPriceRange,

  // Off Market info
  soldDate: defaultValues.propertySoldDate,
  soldPrice: defaultValues.propertySoldPrice,

  // Address
  unitNumber: defaultValues.propertyUnitNumber,
  streetNumber: defaultValues.propertyStreetNumber,
  streetDir: defaultValues.propertyStreetDir,
  streetName: defaultValues.propertyStreetName,
  streetSuffix: defaultValues.propertyStreetSuffix,
  neighborhood: defaultValues.propertyNeighborhood,
  city: defaultValues.propertyCity,
  county: defaultValues.propertyCounty,
  state: defaultValues.propertyState,
  zipCode: defaultValues.propertyZipCode,

  // Rooms
  bedrooms: JSON.parse(JSON.stringify(defaultValues.propertyBedrooms)),
  bathrooms: JSON.parse(JSON.stringify(defaultValues.propertyBathrooms)),
  bathroomDescription: JSON.parse(JSON.stringify(defaultValues.propertyBathroomDescription)),
  fullBaths: defaultValues.propertyFullBaths,
  threeQuarterBaths: defaultValues.propertyThreeQuarterBaths,
  halfBaths: defaultValues.propertyHalfBaths,
  quarterBaths: defaultValues.propertyQuarterBaths,
  kitchen: defaultValues.propertyKitchen,
  diningRoom: defaultValues.propertyDiningRoom,
  diningDescription: JSON.parse(JSON.stringify(defaultValues.propertyDiningDescription)),
  livingRoom: defaultValues.propertyLivingRoom,
  familyRoom: defaultValues.propertyFamilyRoom,
  otherRooms: JSON.parse(JSON.stringify(defaultValues.propertyOtherRooms)),
  basement: JSON.parse(JSON.stringify(defaultValues.propertyBasement)),
  furnished: defaultValues.propertyFurnished,

  // Utilities
  heating: JSON.parse(JSON.stringify(defaultValues.propertyHeating)),
  fuel: JSON.parse(JSON.stringify(defaultValues.propertyFuel)),
  fireplaces: JSON.parse(JSON.stringify(defaultValues.propertyFireplaces)),
  fireplaceCount: defaultValues.propertyFireplaceCount,
  cooling: JSON.parse(JSON.stringify(defaultValues.propertyCooling)),
  water: JSON.parse(JSON.stringify(defaultValues.propertyWater)),
  sewer: JSON.parse(JSON.stringify(defaultValues.propertySewer)),
  appliances: JSON.parse(JSON.stringify(defaultValues.propertyAppliances)),

  // Lot Features
  outbuildings: JSON.parse(JSON.stringify(defaultValues.propertyOutbuildings)),
  frontage: JSON.parse(JSON.stringify(defaultValues.propertyFrontage)),
  garageStalls: defaultValues.propertyGarageStalls,
  otherStalls: defaultValues.propertyOtherStalls,
  garageDimensions: defaultValues.propertyGarageDimensions,
  garageDoorHeight: defaultValues.propertyGarageDoorHeight,
  garageDoorWidth: defaultValues.propertyGarageDoorWidth,
  garage: JSON.parse(JSON.stringify(defaultValues.propertyGarage)),
  driveway: JSON.parse(JSON.stringify(defaultValues.propertyDriveway)),
  roof: JSON.parse(JSON.stringify(defaultValues.propertyRoof)),
  exterior: JSON.parse(JSON.stringify(defaultValues.propertyExterior)),
  fence: JSON.parse(JSON.stringify(defaultValues.propertyFence)),
  lotDimensions: defaultValues.propertyLotDimensions,
  lotFeatures: JSON.parse(JSON.stringify(defaultValues.propertyLotFeatures)),
  waterfrontName: defaultValues.propertyWaterfrontName,
  waterfrontView: JSON.parse(JSON.stringify(defaultValues.propertyWaterfrontView)),
  agriculturalWater: JSON.parse(JSON.stringify(defaultValues.propertyAgriculturalWater)),
  pool: JSON.parse(JSON.stringify(defaultValues.propertyPool)),
  topography: JSON.parse(JSON.stringify(defaultValues.propertyTopography)),

  // Financial status
  specialListingConditions: JSON.parse(JSON.stringify(defaultValues.propertySpecialListingConditions)),
  assessmentPending: defaultValues.propertyAssessmentPending,
  hoaFee: defaultValues.propertyHoaFee,
  hoaFeeFrequency: defaultValues.propertyHoaFeeFrequency,
  monthlyHoaFee: defaultValues.propertyMonthlyHoaFee,
  hoaCompanyName: defaultValues.propertyHoaCompanyName,
  hoaBenefits: JSON.parse(JSON.stringify(defaultValues.propertyHoaBenefits)),
  greenCert: defaultValues.propertyGreenCert,

  // Community
  communityName: defaultValues.propertyCommunityName,
  sharedAmenities: JSON.parse(JSON.stringify(defaultValues.propertySharedAmenities)),
  unitAmenities: JSON.parse(JSON.stringify(defaultValues.propertyUnitAmenities)),
  schoolDistrict: defaultValues.propertySchoolDistrict,
  schoolName: defaultValues.propertySchoolName,
  restrictions: JSON.parse(JSON.stringify(defaultValues.propertyRestrictions)),

  // Data over time
  taxHistory: JSON.parse(JSON.stringify(defaultValues.propertyTaxHistory)),
  priceHistory: JSON.parse(JSON.stringify(defaultValues.propertyPriceHistory)),

  // Extra
  handicapAccess: JSON.parse(JSON.stringify(defaultValues.propertyHandicapAccess)),
  remarks: defaultValues.propertyRemarks,
  presentUse: defaultValues.propertyPresentUse,
  searchSpecialties: JSON.parse(JSON.stringify(defaultValues.propertySearchSpecialties)),
  photos: JSON.parse(JSON.stringify(defaultValues.propertyPhotos)),
  coverPhoto: JSON.parse(JSON.stringify(defaultValues.propertyCoverPhoto)),
  virtualTours: JSON.parse(JSON.stringify(defaultValues.propertyVirtualTours)),
  openHouses: JSON.parse(JSON.stringify(defaultValues.propertyOpenHouses)),

  // Property-specific
  detailedAppliances: JSON.parse(JSON.stringify(defaultValues.propertyDetailedAppliances)),
  userEntered: defaultValues.propertyUserEntered
}

const getters = {
  getUniqueId: (state) => {
    return state.uniqueId
  },
  getEstimatesAllowed: (state) => {
    return state.estimatesAllowed
  },
  getCommentsAllowed: (state) => {
    return state.commentsAllowed
  },
  getListType: (state) => {
    return state.listType
  },
  getSpecialCircumstances: (state) => {
    return state.specialCircumstances
  },
  getBrokerage: (state) => {
    return state.brokerage
  },
  getMlsId: (state) => {
    return state.mlsId
  },
  getParcelId: (state) => {
    return state.parcelId
  },
  getLatitude: (state) => {
    return state.latitude
  },
  getLongitude: (state) => {
    return state.longitude
  },
  getGeoPoint: (state) => {
    return state.geoPoint
  },
  getExpectedMarketDate: (state) => {
    return state.expectedMarketDate
  },
  getDownloadTime: (state) => {
    return state.downloadTime
  },
  getStatus: (state) => {
    return state.status
  },
  getContingency: (state) => {
    return state.contingency
  },
  getPrice: (state) => {
    return state.price
  },
  getBedroomCount: (state) => {
    return state.bedroomCount
  },
  getBathroomCount: (state) => {
    return state.bathroomCount
  },
  getLotAcres: (state) => {
    return state.lotAcres
  },
  getLotSqft: (state) => {
    return state.lotSqft
  },
  getHouseSqft: (state) => {
    return state.houseSqft
  },
  getYearBuilt: (state) => {
    return state.yearBuilt
  },
  getFoundationSize: (state) => {
    return state.foundationSize
  },
  getStories: (state) => {
    return state.stories
  },
  getStyle: (state) => {
    return state.style
  },
  getManufacturedHome: (state) => {
    return state.manufacturedHome
  },
  getAvailableStarting: (state) => {
    return state.availableStarting
  },
  getApplicationFee: (state) => {
    return state.applicationFee
  },
  getRequiredBackgroundCheck: (state) => {
    return state.requiredBackgroundCheck
  },
  getMinLeaseMonths: (state) => {
    return state.minLeaseMonths
  },
  getSmokingPermitted: (state) => {
    return state.smokingPermitted
  },
  getLaundryAvailability: (state) => {
    return state.laundryAvailability
  },
  getOwnerPays: (state) => {
    return state.ownerPays
  },
  getTenantPays: (state) => {
    return state.tenantPays
  },
  getSecurityDeposit: (state) => {
    return state.securityDeposit
  },
  getFees: (state) => {
    return state.fees
  },
  getPrepaidRented: (state) => {
    return state.prepaidRent
  },
  getNewConstruction: (state) => {
    return state.newConstruction
  },
  getBuilderName: (state) => {
    return state.builderName
  },
  getProjectedCompletionDate: (state) => {
    return state.projectedCompletionDate
  },
  getModelLocation: (state) => {
    return state.modelLocation
  },
  getModelHours: (state) => {
    return state.modelHours
  },
  getLowPriceRange: (state) => {
    return state.lowPriceRange
  },
  getHighPriceRange: (state) => {
    return state.highPriceRange
  },
  getSoldDate: (state) => {
    return state.soldDate
  },
  getSoldPrice: (state) => {
    return state.soldPrice
  },
  getUnitNumber: (state) => {
    return state.unitNumber
  },
  getStreetNumber: (state) => {
    return state.streetNumber
  },
  getStreetDir: (state) => {
    return state.streetDir
  },
  getStreetName: (state) => {
    return state.streetName
  },
  getStreetSuffix: (state) => {
    return state.streetSuffix
  },
  getNeighborhood: (state) => {
    return state.neighborhood
  },
  getCity: (state) => {
    return state.city
  },
  getCounty: (state) => {
    return state.county
  },
  getState: (state) => {
    return state.state
  },
  getZipCode: (state) => {
    return state.zipCode
  },
  getBedrooms: (state) => {
    return state.bedrooms
  },
  getBathrooms: (state) => {
    return state.bathrooms
  },
  getBathroomDescription: (state) => {
    return state.bathroomDescription
  },
  getFullBaths: (state) => {
    return state.fullBaths
  },
  getThreeQuarterBaths: (state) => {
    return state.threeQuarterBaths
  },
  getHalfBaths: (state) => {
    return state.halfBaths
  },
  getQuarterBaths: (state) => {
    return state.quarterBaths
  },
  getKitchen: (state) => {
    return state.kitchen
  },
  getDiningRoom: (state) => {
    return state.diningRoom
  },
  getDiningDescription: (state) => {
    return state.diningDescription
  },
  getLivingRoom: (state) => {
    return state.livingRoom
  },
  getFamilyRoom: (state) => {
    return state.familyRoom
  },
  getOtherRooms: (state) => {
    return state.otherRooms
  },
  getBasement: (state) => {
    return state.basement
  },
  getFurnished: (state) => {
    return state.furnished
  },
  getHeating: (state) => {
    return state.heating
  },
  getFuel: (state) => {
    return state.fuel
  },
  getFireplaces: (state) => {
    return state.fireplaces
  },
  getFireplaceCount: (state) => {
    return state.fireplaceCount
  },
  getCooling: (state) => {
    return state.cooling
  },
  getWater: (state) => {
    return state.water
  },
  getSewer: (state) => {
    return state.sewer
  },
  getAppliances: (state) => {
    return state.appliances
  },
  getOutbuildings: (state) => {
    return state.outbuildings
  },
  getFrontage: (state) => {
    return state.frontage
  },
  getGarageStalls: (state) => {
    return state.garageStalls
  },
  getOtherStalls: (state) => {
    return state.otherStalls
  },
  getGarageDimensions: (state) => {
    return state.garageDimensions
  },
  getGarageDoorHeight: (state) => {
    return state.garageDoorHeight
  },
  getGarageDoorWidth: (state) => {
    return state.garageDoorWidth
  },
  getGarage: (state) => {
    return state.garage
  },
  getDriveway: (state) => {
    return state.driveway
  },
  getRoof: (state) => {
    return state.roof
  },
  getExterior: (state) => {
    return state.exterior
  },
  getFence: (state) => {
    return state.fence
  },
  getLotDimensions: (state) => {
    return state.lotDimensions
  },
  getLotFeatures: (state) => {
    return state.lotFeatures
  },
  getWaterfrontName: (state) => {
    return state.waterfrontName
  },
  getWaterfrontView: (state) => {
    return state.waterfrontView
  },
  getAgriculturalWater: (state) => {
    return state.agriculturalWater
  },
  getPool: (state) => {
    return state.pool
  },
  getTopography: (state) => {
    return state.topography
  },
  getSpecialListingConditions: (state) => {
    return state.specialListingConditions
  },
  getAssessmentPending: (state) => {
    return state.assessmentPending
  },
  getHoaFee: (state) => {
    return state.hoaFee
  },
  getHoaFeeFrequency: (state) => {
    return state.hoaFeeFrequency
  },
  getMonthlyHoaFee: (state) => {
    return state.monthlyHoaFee
  },
  getHoaCompanyName: (state) => {
    return state.hoaCompanyName
  },
  getHoaBenefits: (state) => {
    return state.hoaBenefits
  },
  getGreenCert: (state) => {
    return state.greenCert
  },
  getCommunityName: (state) => {
    return state.communityName
  },
  getSharedAmenities: (state) => {
    return state.sharedAmenities
  },
  getUnitAmenities: (state) => {
    return state.unitAmenities
  },
  getSchoolDistrict: (state) => {
    return state.schoolDistrict
  },
  getSchoolName: (state) => {
    return state.schoolName
  },
  getRestrictions: (state) => {
    return state.restrictions
  },
  getTaxHistory: (state) => {
    return state.taxHistory
  },
  getPriceHistory: (state) => {
    return state.priceHistory
  },
  getHandicapAccess: (state) => {
    return state.handicapAccess
  },
  getRemarks: (state) => {
    return state.remarks
  },
  getPresentUse: (state) => {
    return state.presentUse
  },
  getSearchSpecialties: (state) => {
    return state.searchSpecialties
  },
  getPhotos: (state) => {
    return state.photos
  },
  getCoverPhoto: (state) => {
    return state.coverPhoto
  },
  getVirtualTours: (state) => {
    return state.virtualTours
  },
  getOpenHouses: (state) => {
    return state.openHouses
  },
  getDetailedAppliances: (state) => {
    return state.detailedAppliances
  },
  getUserEntered: (state) => {
    return state.userEntered
  }
}
/* Example Mutations
  addToBlockList: (state, id) => {
    if (!state.blockList.includes(id)) {
      state.blockList.push(id)
    }
  },
  removeFromBlockList: (state, id) => {
    var index = state.blockList.indexOf(id)
    if (index > -1) {
      state.blockList.splice(index, 1)
    }
  },
  updateBlockList: (state, blockList) => {
    state.blockList = blockList
  },
*/
const mutations = {
  clearData: (state) => {
    state.uniqueId = defaultValues.uniqueId

    // Functionality implications
    state.estimatesAllowed = defaultValues.propertyEstimatesAllowed
    state.commentsAllowed = defaultValues.propertyCommentsAllowed

    // Administrative information
    state.listType = defaultValues.propertyListType
    state.specialCircumstances = defaultValues.propertySpecialCircumstances
    state.brokerage = defaultValues.propertyBrokerage
    state.mlsId = defaultValues.propertyMlsId
    state.parcelId = JSON.parse(JSON.stringify(defaultValues.propertyParcelId))
    state.latitude = defaultValues.propertyLatitude
    state.longitude = defaultValues.propertyLongitude
    state.geoPoint = defaultValues.propertyGeoPoint
    state.expectedMarketDate = defaultValues.propertyExpectedMarketDate
    state.downloadTime = defaultValues.propertyDownloadTime

    // Overview information
    state.status = defaultValues.propertyStatus
    state.contingency = defaultValues.propertyContingency
    state.price = defaultValues.propertyPrice
    state.bedroomCount = defaultValues.propertyBedroomCount
    state.bathroomCount = defaultValues.propertyBathroomCount
    state.lotAcres = defaultValues.propertyLotAcres
    state.lotSqft = defaultValues.propertyLotSqft
    state.houseSqft = defaultValues.propertyHouseSqft
    state.yearBuilt = defaultValues.propertyYearBuilt
    state.foundationSize = defaultValues.propertyFoundationSize
    state.stories = defaultValues.propertyStories
    state.style = defaultValues.propertyStyle
    state.manufacturedHome = defaultValues.propertyManufacturedHome
    state.availableStarting = defaultValues.propertyAvailableStarting

    // Rental info
    state.applicationFee = defaultValues.propertyApplicationFee
    state.requiredBackgroundCheck = defaultValues.propertyRequiredBackgroundCheck
    state.minLeaseMonths = defaultValues.propertyMinLeaseMonths
    state.smokingPermitted = defaultValues.propertySmokingPermitted
    state.laundryAvailability = defaultValues.propertyLaundryAvailability
    state.ownerPays = JSON.parse(JSON.stringify(defaultValues.propertyOwnerPays))
    state.tenantPays = JSON.parse(JSON.stringify(defaultValues.propertyTenantPays))
    state.securityDeposit = defaultValues.propertySecurityDeposit
    state.fees = JSON.parse(JSON.stringify(defaultValues.propertyFees))
    state.prepaidRent = defaultValues.propertyPrepaidRent

    // Construction info
    state.newConstruction = defaultValues.propertyNewConstruction
    state.builderName = defaultValues.propertyBuilderName
    state.projectedCompletionDate = defaultValues.propertyProjectedCompletionDate
    state.modelLocation = defaultValues.propertyModelLocation
    state.modelHours = defaultValues.propertyModelHours
    state.lowPriceRange = defaultValues.propertyLowPriceRange
    state.highPriceRange = defaultValues.propertyHighPriceRange

    // Off Market info
    state.soldDate = defaultValues.propertySoldDate
    state.soldPrice = defaultValues.propertySoldPrice

    // Address
    state.unitNumber = defaultValues.propertyUnitNumber
    state.streetNumber = defaultValues.propertyStreetNumber
    state.streetDir = defaultValues.propertyStreetDir
    state.streetName = defaultValues.propertyStreetName
    state.streetSuffix = defaultValues.propertyStreetSuffix
    state.neighborhood = defaultValues.propertyNeighborhood
    state.city = defaultValues.propertyCity
    state.county = defaultValues.propertyCounty
    state.state = defaultValues.propertyState
    state.zipCode = defaultValues.propertyZipCode

    // Rooms
    state.bedrooms = JSON.parse(JSON.stringify(defaultValues.propertyBedrooms))
    state.bathrooms = JSON.parse(JSON.stringify(defaultValues.propertyBathrooms))
    state.bathroomDescription = JSON.parse(JSON.stringify(defaultValues.propertyBathroomDescription))
    state.fullBaths = defaultValues.propertyFullBaths
    state.threeQuarterBaths = defaultValues.propertyThreeQuarterBaths
    state.halfBaths = defaultValues.propertyHalfBaths
    state.quarterBaths = defaultValues.propertyQuarterBaths
    state.kitchen = defaultValues.propertyKitchen
    state.diningRoom = defaultValues.propertyDiningRoom
    state.diningDescription = JSON.parse(JSON.stringify(defaultValues.propertyDiningDescription))
    state.livingRoom = defaultValues.propertyLivingRoom
    state.familyRoom = defaultValues.propertyFamilyRoom
    state.otherRooms = JSON.parse(JSON.stringify(defaultValues.propertyOtherRooms))
    state.basement = JSON.parse(JSON.stringify(defaultValues.propertyBasement))
    state.furnished = defaultValues.propertyFurnished

    // Utilities
    state.heating = JSON.parse(JSON.stringify(defaultValues.propertyHeating))
    state.fuel = JSON.parse(JSON.stringify(defaultValues.propertyFuel))
    state.fireplaces = JSON.parse(JSON.stringify(defaultValues.propertyFireplaces))
    state.fireplaceCount = defaultValues.propertyFireplaceCount
    state.cooling = JSON.parse(JSON.stringify(defaultValues.propertyCooling))
    state.water = JSON.parse(JSON.stringify(defaultValues.propertyWater))
    state.sewer = JSON.parse(JSON.stringify(defaultValues.propertySewer))
    state.appliances = JSON.parse(JSON.stringify(defaultValues.propertyAppliances))

    // Lot Features
    state.outbuildings = JSON.parse(JSON.stringify(defaultValues.propertyOutbuildings))
    state.frontage = JSON.parse(JSON.stringify(defaultValues.propertyFrontage))
    state.garageStalls = defaultValues.propertyGarageStalls
    state.otherStalls = defaultValues.propertyOtherStalls
    state.garageDimensions = defaultValues.propertyGarageDimensions
    state.garageDoorHeight = defaultValues.propertyGarageDoorHeight
    state.garageDoorWidth = defaultValues.propertyGarageDoorWidth
    state.garage = JSON.parse(JSON.stringify(defaultValues.propertyGarage))
    state.driveway = JSON.parse(JSON.stringify(defaultValues.propertyDriveway))
    state.roof = JSON.parse(JSON.stringify(defaultValues.propertyRoof))
    state.exterior = JSON.parse(JSON.stringify(defaultValues.propertyExterior))
    state.fence = JSON.parse(JSON.stringify(defaultValues.propertyFence))
    state.lotDimensions = defaultValues.propertyLotDimensions
    state.lotFeatures = JSON.parse(JSON.stringify(defaultValues.propertyLotFeatures))
    state.waterfrontName = defaultValues.propertyWaterfrontName
    state.waterfrontView = JSON.parse(JSON.stringify(defaultValues.propertyWaterfrontView))
    state.agriculturalWater = JSON.parse(JSON.stringify(defaultValues.propertyAgriculturalWater))
    state.pool = JSON.parse(JSON.stringify(defaultValues.propertyPool))
    state.topography = JSON.parse(JSON.stringify(defaultValues.propertyTopography))

    // Financial status
    state.specialListingConditions = JSON.parse(JSON.stringify(defaultValues.propertySpecialListingConditions))
    state.assessmentPending = defaultValues.propertyAssessmentPending
    state.hoaFee = defaultValues.propertyHoaFee
    state.hoaFeeFrequency = defaultValues.propertyHoaFeeFrequency
    state.monthlyHoaFee = defaultValues.propertyMonthlyHoaFee
    state.hoaCompanyName = defaultValues.propertyHoaCompanyName
    state.hoaBenefits = JSON.parse(JSON.stringify(defaultValues.propertyHoaBenefits))
    state.greenCert = defaultValues.propertyGreenCert

    // Community
    state.communityName = defaultValues.propertyCommunityName
    state.sharedAmenities = JSON.parse(JSON.stringify(defaultValues.propertySharedAmenities))
    state.unitAmenities = JSON.parse(JSON.stringify(defaultValues.propertyUnitAmenities))
    state.schoolDistrict = defaultValues.propertySchoolDistrict
    state.schoolName = defaultValues.propertySchoolName
    state.restrictions = JSON.parse(JSON.stringify(defaultValues.propertyRestrictions))

    // Data over time
    state.taxHistory = JSON.parse(JSON.stringify(defaultValues.propertyTaxHistory))
    state.priceHistory = JSON.parse(JSON.stringify(defaultValues.propertyPriceHistory))

    // Extra
    state.handicapAccess = JSON.parse(JSON.stringify(defaultValues.propertyHandicapAccess))
    state.remarks = defaultValues.propertyRemarks
    state.presentUse = defaultValues.propertyPresentUse
    state.searchSpecialties = JSON.parse(JSON.stringify(defaultValues.propertySearchSpecialties))
    state.photos = JSON.parse(JSON.stringify(defaultValues.propertyPhotos))
    state.coverPhoto = JSON.parse(JSON.stringify(defaultValues.propertyCoverPhoto))
    state.virtualTours = JSON.parse(JSON.stringify(defaultValues.propertyVirtualTours))
    state.openHouses = JSON.parse(JSON.stringify(defaultValues.propertyOpenHouses))

    // Property-specific
    state.detailedAppliances = JSON.parse(JSON.stringify(defaultValues.propertyDetailedAppliances))
    state.userEntered = defaultValues.propertyUserEntered
  },
  updateUniqueId: (state, uniqueId) => {
    state.uniqueId = uniqueId
  },
  updateEstimatesAllowed: (state, estimatesAllowed) => {
    state.estimatesAllowed = estimatesAllowed
  },
  updateCommentsAllowed: (state, commentsAllowed) => {
    state.commentsAllowed = commentsAllowed
  },
  updateListType: (state, listType) => {
    state.listType = listType
  },
  updateSpecialCircumstances: (state, specialCircumstances) => {
    state.specialCircumstances = specialCircumstances
  },
  updateBrokerage: (state, brokerage) => {
    state.brokerage = brokerage
  },
  updateMlsId: (state, mlsId) => {
    state.mlsId = mlsId
  },
  updateParcelId: (state, parcelId) => {
    state.parcelId = parcelId
  },
  updateLatitude: (state, latitude) => {
    state.latitude = latitude
  },
  updateLongitude: (state, longitude) => {
    state.longitude = longitude
  },
  updateGeoPoint: (state, geoPoint) => {
    state.geoPoint = geoPoint
  },
  updateExpectedMarketDate: (state, expectedMarketDate) => {
    state.expectedMarketDate = expectedMarketDate
  },
  updateDownloadTime: (state, downloadTime) => {
    state.downloadTime = downloadTime
  },
  updateStatus: (state, status) => {
    state.status = status
  },
  updateContingency: (state, contingency) => {
    state.contingency = contingency
  },
  updatePrice: (state, price) => {
    state.price = price
  },
  updateBedroomCount: (state, bedroomCount) => {
    state.bedroomCount = bedroomCount
  },
  updateBathroomCount: (state, bathroomCount) => {
    state.bathroomCount = bathroomCount
  },
  updateLotAcres: (state, lotAcres) => {
    state.lotAcres = lotAcres
  },
  updateLotSqft: (state, lotSqft) => {
    state.lotSqft = lotSqft
  },
  updateHouseSqft: (state, houseSqft) => {
    state.houseSqft = houseSqft
  },
  updateYearBuilt: (state, yearBuilt) => {
    state.yearBuilt = yearBuilt
  },
  updateFoundationSize: (state, foundationSize) => {
    state.foundationSize = foundationSize
  },
  updateStories: (state, stories) => {
    state.stories = stories
  },
  updateStyle: (state, style) => {
    state.style = style
  },
  updateManufacturedHome: (state, manufacturedHome) => {
    state.manufacturedHome = manufacturedHome
  },
  updateAvailableStarting: (state, availableStarting) => {
    state.availableStarting = availableStarting
  },
  updateApplicationFee: (state, applicationFee) => {
    state.applicationFee = applicationFee
  },
  updateRequiredBackgroundCheck: (state, requiredBackgroundCheck) => {
    state.requiredBackgroundCheck = requiredBackgroundCheck
  },
  updateMinLeaseMonths: (state, minLeaseMonths) => {
    state.minLeaseMonths = minLeaseMonths
  },
  updateSmokingPermitted: (state, smokingPermitted) => {
    state.smokingPermitted = smokingPermitted
  },
  updateLaundryAvailability: (state, laundryAvailability) => {
    state.laundryAvailability = laundryAvailability
  },
  updateOwnerPays: (state, ownerPays) => {
    state.ownerPays = ownerPays
  },
  updateTenantPays: (state, tenantPays) => {
    state.tenantPays = tenantPays
  },
  updateSecurityDeposit: (state, securityDeposit) => {
    state.securityDeposit = securityDeposit
  },
  updateFees: (state, fees) => {
    state.fees = fees
  },
  updatePrepaidRent: (state, prepaidRent) => {
    state.prepaidRent = prepaidRent
  },
  updateNewConstruction: (state, newConstruction) => {
    state.newConstruction = newConstruction
  },
  updateBuilderName: (state, builderName) => {
    state.builderName = builderName
  },
  updateProjectedCompletionDate: (state, projectedCompletionDate) => {
    state.projectedCompletionDate = projectedCompletionDate
  },
  updateModelLocation: (state, modelLocation) => {
    state.modelLocation = modelLocation
  },
  updateModelHours: (state, modelHours) => {
    state.modelHours = modelHours
  },
  updateLowPriceRange: (state, lowPriceRange) => {
    state.lowPriceRange = lowPriceRange
  },
  updateHighPriceRange: (state, highPriceRange) => {
    state.highPriceRange = highPriceRange
  },
  updateSoldDate: (state, soldDate) => {
    state.soldDate = soldDate
  },
  updateSoldPrice: (state, soldPrice) => {
    state.soldPrice = soldPrice
  },
  updateUnitNumber: (state, unitNumber) => {
    state.unitNumber = unitNumber
  },
  updateStreetNumber: (state, streetNumber) => {
    state.streetNumber = streetNumber
  },
  updateStreetDir: (state, streetDir) => {
    state.streetDir = streetDir
  },
  updateStreetName: (state, streetName) => {
    state.streetName = streetName
  },
  updateStreetSuffix: (state, streetSuffix) => {
    state.streetSuffix = streetSuffix
  },
  updateNeighborhood: (state, neighborhood) => {
    state.neighborhood = neighborhood
  },
  updateCity: (state, city) => {
    state.city = city
  },
  updateCounty: (state, county) => {
    state.county = county
  },
  updateState: (state, stateOrProvince) => {
    state.state = stateOrProvince
  },
  updateZipCode: (state, zipCode) => {
    state.zipCode = zipCode
  },
  updateBedrooms: (state, bedrooms) => {
    state.bedrooms = bedrooms
  },
  updateBathrooms: (state, bathrooms) => {
    state.bathrooms = bathrooms
  },
  updateBathroomDescription: (state, bathroomDescription) => {
    state.bathroomDescription = bathroomDescription
  },
  updateFullBaths: (state, fullBaths) => {
    state.fullBaths = fullBaths
  },
  updateThreeQuarterBaths: (state, threeQuarterBaths) => {
    state.threeQuarterBaths = threeQuarterBaths
  },
  updateHalfBaths: (state, halfBaths) => {
    state.halfBaths = halfBaths
  },
  updateQuarterBaths: (state, quarterBaths) => {
    state.quarterBaths = quarterBaths
  },
  updateKitchen: (state, kitchen) => {
    state.kitchen = kitchen
  },
  updateDiningRoom: (state, diningRoom) => {
    state.diningRoom = diningRoom
  },
  updateDiningDescription: (state, diningDescription) => {
    state.diningDescription = diningDescription
  },
  updateLivingRoom: (state, livingRoom) => {
    state.livingRoom = livingRoom
  },
  updateFamilyRoom: (state, familyRoom) => {
    state.familyRoom = familyRoom
  },
  updateOtherRooms: (state, otherRooms) => {
    state.otherRooms = otherRooms
  },
  updateBasement: (state, basement) => {
    state.basement = basement
  },
  updateFurnished: (state, furnished) => {
    state.furnished = furnished
  },
  updateHeating: (state, heating) => {
    state.heating = heating
  },
  updateFuel: (state, fuel) => {
    state.fuel = fuel
  },
  updateFireplaces: (state, fireplaces) => {
    state.fireplaces = fireplaces
  },
  updateFireplaceCount: (state, fireplaceCount) => {
    state.fireplaceCount = fireplaceCount
  },
  updateCooling: (state, cooling) => {
    state.cooling = cooling
  },
  updateWater: (state, water) => {
    state.water = water
  },
  updateSewer: (state, sewer) => {
    state.sewer = sewer
  },
  updateAppliances: (state, appliances) => {
    state.appliances = appliances
  },
  updateOutbuildings: (state, outbuildings) => {
    state.outbuildings = outbuildings
  },
  updateFrontage: (state, frontage) => {
    state.frontage = frontage
  },
  updateGarageStalls: (state, garageStalls) => {
    state.garageStalls = garageStalls
  },
  updateOtherStalls: (state, otherStalls) => {
    state.otherStalls = otherStalls
  },
  updateGarageDimensions: (state, garageDimensions) => {
    state.garageDimensions = garageDimensions
  },
  updateGarageDoorHeight: (state, garageDoorHeight) => {
    state.garageDoorHeight = garageDoorHeight
  },
  updateGarageDoorWidth: (state, garageDoorWidth) => {
    state.garageDoorWidth = garageDoorWidth
  },
  updateGarage: (state, garage) => {
    state.garage = garage
  },
  updateDriveway: (state, driveway) => {
    state.driveway = driveway
  },
  updateRoof: (state, roof) => {
    state.roof = roof
  },
  updateExterior: (state, exterior) => {
    state.exterior = exterior
  },
  updateFence: (state, fence) => {
    state.fence = fence
  },
  updateLotDimensions: (state, lotDimensions) => {
    state.lotDimensions = lotDimensions
  },
  updateLotFeatures: (state, lotFeatures) => {
    state.lotFeatures = lotFeatures
  },
  updateWaterfrontName: (state, waterfrontName) => {
    state.waterfrontName = waterfrontName
  },
  updateWaterfrontView: (state, waterfrontView) => {
    state.waterfrontView = waterfrontView
  },
  updateAgriculturalWater: (state, agriculturalWater) => {
    state.agriculturalWater = agriculturalWater
  },
  updatePool: (state, pool) => {
    state.pool = pool
  },
  updateTopography: (state, topography) => {
    state.topography = topography
  },
  updateSpecialListingConditions: (state, specialListingConditions) => {
    state.specialListingConditions = specialListingConditions
  },
  updateAssessmentPending: (state, assessmentPending) => {
    state.assessmentPending = assessmentPending
  },
  updateHoaFee: (state, hoaFee) => {
    state.hoaFee = hoaFee
  },
  updateHoaFeeFrequency: (state, hoaFeeFrequency) => {
    state.hoaFeeFrequency = hoaFeeFrequency
  },
  updateMonthlyHoaFee: (state, monthlyHoaFee) => {
    state.monthlyHoaFee = monthlyHoaFee
  },
  updateHoaCompanyName: (state, hoaCompanyName) => {
    state.hoaCompanyName = hoaCompanyName
  },
  updateHoaBenefits: (state, hoaBenefits) => {
    state.hoaBenefits = hoaBenefits
  },
  updateGreenCert: (state, greenCert) => {
    state.greenCert = greenCert
  },
  updateCommunityName: (state, communityName) => {
    state.communityName = communityName
  },
  updateSharedAmenities: (state, sharedAmenities) => {
    state.sharedAmenities = sharedAmenities
  },
  updateUnitAmenities: (state, unitAmenities) => {
    state.unitAmenities = unitAmenities
  },
  updateSchoolDistrict: (state, schoolDistrict) => {
    state.schoolDistrict = schoolDistrict
  },
  updateSchoolName: (state, schoolName) => {
    state.schoolName = schoolName
  },
  updateRestrictions: (state, restrictions) => {
    state.restrictions = restrictions
  },
  updateTaxHistory: (state, taxHistory) => {
    state.taxHistory = taxHistory
  },
  updatePriceHistory: (state, priceHistory) => {
    state.priceHistory = priceHistory
  },
  updateHandicapAccess: (state, handicapAccess) => {
    state.handicapAccess = handicapAccess
  },
  updateRemarks: (state, remarks) => {
    state.remarks = remarks
  },
  updatePresentUse: (state, presentUse) => {
    state.presentUse = presentUse
  },
  updateSearchSpecialties: (state, searchSpecialties) => {
    state.searchSpecialties = searchSpecialties
  },
  updatePhotos: (state, photos) => {
    state.photos = photos
  },
  updateCoverPhoto: (state, photo) => {
    state.coverPhoto = photo
  },
  updateVirtualTours: (state, virtualTours) => {
    state.virtualTours = virtualTours
  },
  updateOpenHouses: (state, openHouses) => {
    state.openHouses = openHouses
  },
  addToDetailedAppliances: (state, applianceObject) => {
    state.detailedAppliances.push(applianceObject)
  },
  removeIndexFromDetailedAppliances: (state, index) => {
    if (index > -1) {
      state.detailedAppliances.splice(index, 1)
    }
  },
  replaceIndexFromDetailedAppliances: (state, { index, applianceObject }) => {
    if (index > -1) {
      state.detailedAppliances.splice(index, 1, applianceObject)
    }
  },
  updateDetailedAppliances: (state, detailedAppliances) => {
    state.detailedAppliances = detailedAppliances
  },
  updateUserEntered: (state, userEntered) => {
    state.userEntered = userEntered
  }
}

const actions = {
  async getProperty ({ commit, state, rootGetters }, uniqueId) {
    var client = rootGetters.getPropertyApigClientFactory
    var params = {'unique_id': uniqueId}
    var pathTemplate = '/properties/{unique_id}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      if (!rootGetters.getSecretAccessKey || !rootGetters.getAccessKeyId) return
      AWS.config.update({
        credentials: new AWS.Credentials(rootGetters.getAccessKeyId, rootGetters.getSecretAccessKey, rootGetters.getSessionToken),
        region: window.CONFIG.Region
      })
      var response = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      var propertyData = response.data
      if ('unique_id' in propertyData) commit('updateUniqueId', propertyData.unique_id)
      if ('estimates_allowed' in propertyData) commit('updateEstimatesAllowed', propertyData.estimates_allowed)
      if ('comments_allowed' in propertyData) commit('updateCommentsAllowed', propertyData.comments_allowed)
      if ('list_type' in propertyData) commit('updateListType', propertyData.list_type)
      if ('special_circumstances' in propertyData) commit('updateSpecialCircumstances', propertyData.special_circumstances)
      if ('brokerage' in propertyData) commit('updateBrokerage', propertyData.brokerage)
      if ('mls_id' in propertyData) commit('updateMlsId', propertyData.mls_id)
      if ('parcel_id' in propertyData) commit('updateParcelId', propertyData.parcel_id)
      if ('latitude' in propertyData) commit('updateLatitude', propertyData.latitude)
      if ('longitude' in propertyData) commit('updateLongitude', propertyData.longitude)
      if ('geo_point' in propertyData) commit('updateGeoPoint', propertyData.geo_point)
      if ('expected_market_date' in propertyData) commit('updateExpectedMarketDate', propertyData.expected_market_date)
      if ('download_time' in propertyData) commit('updateDownloadTime', propertyData.download_time)
      if ('status' in propertyData) commit('updateStatus', propertyData.status)
      if ('contingency' in propertyData) commit('updateContingency', propertyData.contingency)
      if ('price' in propertyData) commit('updatePrice', propertyData.price)
      if ('bedroom_count' in propertyData) commit('updateBedroomCount', propertyData.bedroom_count)
      if ('bathroom_count' in propertyData) commit('updateBathroomCount', propertyData.bathroom_count)
      if ('lot_acres' in propertyData) commit('updateLotAcres', propertyData.lot_acres)
      if ('lot_sqft' in propertyData) commit('updateLotSqft', propertyData.lot_sqft)
      if ('house_sqft' in propertyData) commit('updateHouseSqft', propertyData.house_sqft)
      if ('year_built' in propertyData) commit('updateYearBuilt', propertyData.year_built)
      if ('foundation_size' in propertyData) commit('updateFoundationSize', propertyData.foundation_size)
      if ('stories' in propertyData) commit('updateStories', propertyData.stories)
      if ('style' in propertyData) commit('updateStyle', propertyData.style)
      if ('manufactured_home' in propertyData) commit('updateManufacturedHome', propertyData.manufactured_home)
      if ('available_starting' in propertyData) commit('updateAvailableStarting', propertyData.available_starting)
      if ('application_fee' in propertyData) commit('updateApplicationFee', propertyData.application_fee)
      if ('required_background_check' in propertyData) commit('updateRequiredBackgroundCheck', propertyData.required_background_check)
      if ('min_lease_months' in propertyData) commit('updateMinLeaseMonths', propertyData.min_lease_months)
      if ('smoking_permitted' in propertyData) commit('updateSmokingPermitted', propertyData.smoking_permitted)
      if ('laundry_availability' in propertyData) commit('updateLaundryAvailability', propertyData.laundry_availability)
      if ('owner_pays' in propertyData) commit('updateOwnerPays', propertyData.owner_pays)
      if ('tenant_pays' in propertyData) commit('updateTenantPays', propertyData.tenant_pays)
      if ('security_deposit' in propertyData) commit('updateSecurityDeposit', propertyData.security_deposit)
      if ('fees' in propertyData) commit('updateFees', propertyData.fees)
      if ('prepaid_rent' in propertyData) commit('updatePrepaidRent', propertyData.prepaid_rent)
      if ('new_construction' in propertyData) commit('updateNewConstruction', propertyData.new_construction)
      if ('builder_name' in propertyData) commit('updateBuilderName', propertyData.builder_name)
      if ('projected_completion_date' in propertyData) commit('updateProjectedCompletionDate', propertyData.projected_completion_date)
      if ('model_location' in propertyData) commit('updateModelLocation', propertyData.model_location)
      if ('model_hours' in propertyData) commit('updateModelHours', propertyData.model_hours)
      if ('low_price_range' in propertyData) commit('updateLowPriceRange', propertyData.low_price_range)
      if ('high_price_range' in propertyData) commit('updateHighPriceRange', propertyData.high_price_range)
      if ('sold_date' in propertyData) commit('updateSoldDate', propertyData.sold_date)
      if ('sold_price' in propertyData) commit('updateSoldPrice', propertyData.sold_price)
      if ('unit_number' in propertyData) commit('updateUnitNumber', propertyData.unit_number)
      if ('street_number' in propertyData) commit('updateStreetNumber', propertyData.street_number)
      if ('street_dir' in propertyData) commit('updateStreetDir', propertyData.street_dir)
      if ('street_name' in propertyData) commit('updateStreetName', propertyData.street_name)
      if ('street_suffix' in propertyData) commit('updateStreetSuffix', propertyData.street_suffix)
      if ('neighborhood' in propertyData) commit('updateNeighborhood', propertyData.neighborhood)
      if ('city' in propertyData) commit('updateCity', propertyData.city)
      if ('county' in propertyData) commit('updateCounty', propertyData.county)
      if ('state' in propertyData) commit('updateState', propertyData.state)
      if ('zip_code' in propertyData) commit('updateZipCode', propertyData.zip_code)
      if ('bedrooms' in propertyData) commit('updateBedrooms', propertyData.bedrooms)
      if ('bathrooms' in propertyData) commit('updateBathrooms', propertyData.bathrooms)
      if ('bathroom_description' in propertyData) commit('updateBathroomDescription', propertyData.bathroom_description)
      if ('full_baths' in propertyData) commit('updateFullBaths', propertyData.full_baths)
      if ('three_quarter_baths' in propertyData) commit('updateThreeQuarterBaths', propertyData.three_quarter_baths)
      if ('half_baths' in propertyData) commit('updateHalfBaths', propertyData.half_baths)
      if ('quarter_baths' in propertyData) commit('updateQuarterBaths', propertyData.quarter_baths)
      if ('kitchen' in propertyData) commit('updateKitchen', propertyData.kitchen)
      if ('dining_room' in propertyData) commit('updateDiningRoom', propertyData.dining_room)
      if ('dining_description' in propertyData) commit('updateDiningDescription', propertyData.dining_description)
      if ('living_room' in propertyData) commit('updateLivingRoom', propertyData.living_room)
      if ('family_room' in propertyData) commit('updateFamilyRoom', propertyData.family_room)
      if ('other_rooms' in propertyData) commit('updateOtherRooms', propertyData.other_rooms)
      if ('basement' in propertyData) commit('updateBasement', propertyData.basement)
      if ('furnished' in propertyData) commit('updateFurnished', propertyData.furnished)
      if ('heating' in propertyData) commit('updateHeating', propertyData.heating)
      if ('fuel' in propertyData) commit('updateFuel', propertyData.fuel)
      if ('fireplaces' in propertyData) commit('updateFireplaces', propertyData.fireplaces)
      if ('fireplace_count' in propertyData) commit('updateFireplaceCount', propertyData.fireplace_count)
      if ('cooling' in propertyData) commit('updateCooling', propertyData.cooling)
      if ('water' in propertyData) commit('updateWater', propertyData.water)
      if ('sewer' in propertyData) commit('updateSewer', propertyData.sewer)
      if ('appliances' in propertyData) commit('updateAppliances', propertyData.appliances)
      if ('outbuildings' in propertyData) commit('updateOutbuildings', propertyData.outbuildings)
      if ('frontage' in propertyData) commit('updateFrontage', propertyData.frontage)
      if ('garage_stalls' in propertyData) commit('updateGarageStalls', propertyData.garage_stalls)
      if ('other_stalls' in propertyData) commit('updateOtherStalls', propertyData.other_stalls)
      if ('garage_dimensions' in propertyData) commit('updateGarageDimensions', propertyData.garage_dimensions)
      if ('garage_door_height' in propertyData) commit('updateGarageDoorHeight', propertyData.garage_door_height)
      if ('garage_door_width' in propertyData) commit('updateGarageDoorWidth', propertyData.garage_door_width)
      if ('garage' in propertyData) commit('updateGarage', propertyData.garage)
      if ('driveway' in propertyData) commit('updateDriveway', propertyData.driveway)
      if ('roof' in propertyData) commit('updateRoof', propertyData.roof)
      if ('exterior' in propertyData) commit('updateExterior', propertyData.exterior)
      if ('fence' in propertyData) commit('updateFence', propertyData.fence)
      if ('lot_dimensions' in propertyData) commit('updateLotDimensions', propertyData.lot_dimensions)
      if ('lot_features' in propertyData) commit('updateLotFeatures', propertyData.lot_features)
      if ('waterfront_name' in propertyData) commit('updateWaterfrontName', propertyData.waterfront_name)
      if ('waterfront_view' in propertyData) commit('updateWaterfrontView', propertyData.waterfront_view)
      if ('agricultural_water' in propertyData) commit('updateAgriculturalWater', propertyData.agricultural_water)
      if ('pool' in propertyData) commit('updatePool', propertyData.pool)
      if ('topography' in propertyData) commit('updateTopography', propertyData.topography)
      if ('special_listing_conditions' in propertyData) commit('updateSpecialListingConditions', propertyData.special_listing_conditions)
      if ('assessment_pending' in propertyData) commit('updateAssessmentPending', propertyData.assessment_pending)
      if ('hoa_fee' in propertyData) commit('updateHoaFee', propertyData.hoa_fee)
      if ('hoa_fee_frequency' in propertyData) commit('updateHoaFeeFrequency', propertyData.hoa_fee_frequency)
      if ('monthly_hoa_fee' in propertyData) commit('updateMonthlyHoaFee', propertyData.monthly_hoa_fee)
      if ('hoa_company_name' in propertyData) commit('updateHoaCompanyName', propertyData.hoa_company_name)
      if ('hoa_benefits' in propertyData) commit('updateHoaBenefits', propertyData.hoa_benefits)
      if ('green_cert' in propertyData) commit('updateGreenCert', propertyData.green_cert)
      if ('community_name' in propertyData) commit('updateCommunityName', propertyData.community_name)
      if ('shared_amenities' in propertyData) commit('updateSharedAmenities', propertyData.shared_amenities)
      if ('unit_amenities' in propertyData) commit('updateUnitAmenities', propertyData.unit_amenities)
      if ('school_district' in propertyData) commit('updateSchoolDistrict', propertyData.school_district)
      if ('school_name' in propertyData) commit('updateSchoolName', propertyData.school_name)
      if ('restrictions' in propertyData) commit('updateRestrictions', propertyData.restrictions)
      if ('tax_history' in propertyData) commit('updateTaxHistory', propertyData.tax_history)
      if ('price_history' in propertyData) commit('updatePriceHistory', propertyData.price_history)
      if ('handicap_access' in propertyData) commit('updateHandicapAccess', propertyData.handicap_access)
      if ('remarks' in propertyData) commit('updateRemarks', propertyData.remarks)
      if ('present_use' in propertyData) commit('updatePresentUse', propertyData.present_use)
      if ('search_specialties' in propertyData) commit('updateSearchSpecialties', propertyData.search_specialties)
      if ('photos' in propertyData) {
        if (propertyData.photos.length === 0) return
        var signedPhotos = {
          small: [],
          medium: [],
          large: []
        }
        var s3 = new S3()
        propertyData.photos.sort()
        Object.keys(signedPhotos).forEach((key) => {
          propertyData.photos.forEach((photoName) => {
            var photoArray = photoName.split('/')
            photoArray.shift()
            var photoKey = key + '/' + photoArray.join('/')
            var params = {
              Bucket: window.CONFIG.MLSPhotoBucketName,
              Key: photoKey
            }
            signedPhotos[key].push(s3.getSignedUrl('getObject', params))
          })
        })
        commit('updatePhotos', signedPhotos)
        commit('updateCoverPhoto', signedPhotos.large[0])
      }
      if ('virtual_tours' in propertyData) commit('updateVirtualTours', propertyData.virtual_tours)
      if ('open_houses' in propertyData) commit('updateOpenHouses', propertyData.open_houses)
      if ('detailed_appliances' in propertyData) commit('updateDetailedAppliances', propertyData.detailed_appliances)
      if ('user_entered' in propertyData) commit('updateUserEntered', propertyData.user_entered)
    } catch (error) {
      console.log(error)
    }
  },
  async putPropertyData ({ commit, state, rootGetters }, { uniqueId, method = 'PUT' }) {
    var client = rootGetters.getPropertyApigClientFactory
    var params = {'unique_id': uniqueId}
    var pathTemplate = '/properties/{unique_id}'
    var additionalParams = {}
    var body = {
      'estimates_allowed': state.estimatesAllowed,
      'comments_allowed': state.commentsAllowed,
      'list_type': state.listType,
      'special_circumstances': state.specialCircumstances,
      'brokerage': state.brokerage,
      'mls_id': state.mlsId,
      'parcel_id': state.parcelId,
      'latitude': state.latitude,
      'longitude': state.longitude,
      'geo_point': state.geoPoint,
      'expected_market_date': state.expectedMarketDate,
      'download_time': state.downloadTime,
      'status': state.status,
      'contingency': state.contingency,
      'price': state.price,
      'bedroom_count': state.bedroomCount,
      'bathroom_count': state.bathroomCount,
      'lot_acres': state.lotAcres,
      'lot_sqft': state.lotSqft,
      'house_sqft': state.houseSqft,
      'year_built': state.yearBuilt,
      'foundation_size': state.foundationSize,
      'stories': state.stories,
      'style': state.style,
      'manufactured_home': state.manufacturedHome,
      'available_starting': state.availableStarting,
      'application_fee': state.applicationFee,
      'required_background_check': state.requiredBackgroundCheck,
      'min_lease_months': state.minLeaseMonths,
      'smoking_permitted': state.smokingPermitted,
      'laundry_availability': state.laundryAvailability,
      'owner_pays': state.ownerPays,
      'tenant_pays': state.tenantPays,
      'security_deposit': state.securityDeposit,
      'fees': state.fees,
      'prepaid_rent': state.prepaidRent,
      'new_construction': state.newConstruction,
      'builder_name': state.builderName,
      'projected_completion_date': state.projectedCompletionDate,
      'model_location': state.modelLocation,
      'model_hours': state.modelHours,
      'low_price_range': state.lowPriceRange,
      'high_price_range': state.highPriceRange,
      'sold_date': state.soldDate,
      'sold_price': state.soldPrice,
      'unit_number': state.unitNumber,
      'street_number': state.streetNumber,
      'street_dir': state.streetDir,
      'street_name': state.streetName,
      'street_suffix': state.streetSuffix,
      'neighborhood': state.neighborhood,
      'city': state.city,
      'county': state.county,
      'state': state.state,
      'zip_code': state.zipCode,
      'bedrooms': state.bedrooms,
      'bathrooms': state.bathrooms,
      'bathroom_description': state.bathroomDescription,
      'full_baths': state.fullBaths,
      'three_quarter_baths': state.threeQuarterBaths,
      'half_baths': state.halfBaths,
      'quarter_baths': state.quarterBaths,
      'kitchen': state.kitchen,
      'dining_room': state.diningRoom,
      'dining_description': state.diningDescription,
      'living_room': state.livingRoom,
      'family_room': state.familyRoom,
      'other_rooms': state.otherRooms,
      'basement': state.basement,
      'furnished': state.furnished,
      'heating': state.heating,
      'fuel': state.fuel,
      'fireplaces': state.fireplaces,
      'fireplace_count': state.fireplaceCount,
      'cooling': state.cooling,
      'water': state.water,
      'sewer': state.sewer,
      'appliances': state.appliances,
      'outbuildings': state.outBuildings,
      'frontage': state.frontage,
      'garage_stalls': state.garageStalls,
      'other_stalls': state.otherStalls,
      'garage_dimensions': state.garageDimensions,
      'garage_door_height': state.garageDoorHeight,
      'garage_door_width': state.garageDoorWidth,
      'garage': state.garage,
      'driveway': state.driveway,
      'roof': state.roof,
      'exterior': state.exterior,
      'fence': state.fence,
      'lot_dimensions': state.lotDimensions,
      'lot_features': state.lotFeatures,
      'waterfront_name': state.waterfrontName,
      'waterfront_view': state.waterfrontView,
      'agricultural_water': state.agriculturalWater,
      'pool': state.pool,
      'topography': state.topography,
      'special_listing_conditions': state.specialListingConditions,
      'assessment_pending': state.assessmentPending,
      'hoa_fee': state.hoaFee,
      'hoa_fee_frequency': state.hoaFeeFrequency,
      'monthly_hoa_fee': state.monthlyHoaFee,
      'hoa_company_name': state.hoaCompanyName,
      'hoa_benefits': state.hoaBenefits,
      'green_cert': state.greenCert,
      'community_name': state.communityName,
      'shared_amenities': state.sharedAmenities,
      'unit_amenities': state.unitAmenities,
      'school_district': state.schoolDistrict,
      'school_name': state.schoolName,
      'restrictions': state.restrictions,
      'tax_history': state.taxHistory,
      'price_history': state.priceHistory,
      'handicap_access': state.handicapAccess,
      'remarks': state.remarks,
      'present_use': state.presentUse,
      'search_specialties': state.searchSpecialties,
      'photos': state.photos,
      'virtual_tours': state.virtualTours,
      'open_houses': state.openHouses,
      'detailed_appliances': state.detailedAppliances,
      'user_entered': state.userEntered
    }
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/property.js